import SharePointUpload from '../components/psc/lib/SharePointUpload'

const DocumentSharePointUpload = () => {
    return (
        <SharePointUpload
            entityType="Document"
            apiPath="documents"
            statusField="document_status"
        />
    )
};

export default DocumentSharePointUpload
